module.exports = __webpack_public_path__ + "img/icon-02.8210e239.png";